import { gql, useQuery } from "@apollo/client"
import { Company } from "@oysterhr/schema"

const COMPANY_ENGAGEMENTS_QUERY = gql`
  query CompanyEngagementsQuery($companyId: ID!, $query: String) {
    company(companyId: $companyId) {
      id
      engagements(query: $query, perPage: 200) {
        collection {
          id
          teamMemberName
          cartaId
        }
      }
    }
  }
`

export const useCompanyEngagements = (companyId: string, query?: string) => {
  return useQuery<{ company: Company }>(COMPANY_ENGAGEMENTS_QUERY, {
    variables: { companyId, query },
  })
}
